import { User } from 'firebase';
import { createContext } from 'react';

export const AuthContext = createContext<null | false | User>(null);
